import { render, staticRenderFns } from "./MedicalApplications.vue?vue&type=template&id=a519a8dc"
import script from "./MedicalApplications.vue?vue&type=script&lang=js"
export * from "./MedicalApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports